import axios from "axios";
import { getUserList } from "@store/action/access_control/RolesAction";
import { handleSuccessOne } from "@store/action/GlobalAction";

const REACT_APP_MANAGE_USERS = process.env.REACT_APP_MANAGE_USERS;

export const addUser = (data, func, params) => (dispatch) => {
  axios
    .post(`${REACT_APP_MANAGE_USERS}/users`, data)
    .then((res) => {
      dispatch({
        type: "ADD_USER_SUCCESS",
      });
      func();
      dispatch(getUserList(params));
      handleSuccessOne(res.data.message);
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ADD_USER_FAIL",
          payload: err.response.data?.data,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_USER_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const get_users_by_product = (params) => (dispatch) => {
  axios
    .get(`${REACT_APP_MANAGE_USERS}/fo/users/product`, { params })
    .then((res) => {
      const users = res?.data?.data?.data;
      dispatch({ type: "GET_USERS_BY_PRODUCT_ID", payload: users });
    });
};
